<template>
  <div>
    <v-row class="mb-6">
      <v-col cols="12" lg="3">
        <v-menu v-model="showFromPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
          offset-y min-width="290px" max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="dataBody.from_date" v-bind:label="$t('fromDate')" prepend-icon="mdi-calendar-range"
              v-on="on" clearable @click:clear="() => clearFiltration('from_date')" color="success"></v-text-field>
          </template>
          <v-date-picker @change="FilterData" color="green lighten-1" v-model="dataBody.from_date"
            @input="showFromPicker = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" lg="3">
        <v-menu @change="FilterData" v-model="showToPicker" :close-on-content-click="false" :nudge-right="40"
          transition="scale-transition" offset-y min-width="290px" max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="dataBody.to_date" v-bind:label="$t('toDate')" prepend-icon="mdi-calendar-range"
              v-on="on" clearable @click:clear="() => clearFiltration('to_date')" :disabled="!dataBody.from_date" color="success"></v-text-field>
          </template>
          <v-date-picker @change="FilterData" color="green lighten-1" v-model="dataBody.to_date"
            @input="showToPicker = false" :allowed-dates="checkAllowedDates"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" lg="2">
        <v-select @change="FilterData" v-model="course_type" :items="items" :item-text="'label'" :item-value="'value'"
          v-bind:label="$t('course_Type')"></v-select>
      </v-col>

      <v-col cols="12" lg="4">
        <v-select @change="FilterData" item-value="id" item-text="name" :items="programs" v-model="dataBody.program"
          v-bind:label="$t('Program')"></v-select>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headersTitles"
      :items="upcommingSessions"
      item-key="id"
      class="elevation-1"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
				'show-current-page': true,
				showFirstLastPage: true,
				firstIcon: 'mdi-arrow-collapse-left',
				lastIcon: 'mdi-arrow-collapse-right',
        }"
      mobile-breakpoint="992"
      :no-data-text="`${$t('noResultsHere')}`"
    >
        <template v-slot:item.startOnZoom="{ item }">
              <v-btn
                v-if="
                  isSessionTime(item) && (!inMeeting || inMeeting == 'false')
                "
                class="action-btn"
                type="button"
                color="green lighten-1"
                small
                shaped
                @click="joinOnZoom(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("start") }}
              </v-btn>

              <v-btn
                v-else
                disabled
                class="action-btn"
                type="button"
                color="green lighten-1"
                small
                shaped
                @click="joinOnZoom(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("start") }}
              </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import moment from "moment";

export default {
  mixins: [GlobalMixin],
  data() {
    return {
      filterDataBody: {},
      todayDate: "",
      filterByProgramme: false,
      course_type: "",
      timeNow: "",
      data: {},
      pages: null,
      dataBody: {},
      page: 1,
      pageSize: 2,
      limit: 10,
      fromDateVal: "",
      toDateVal: "",
      showFromPicker: false,
      showToPicker: false,
      upcommingSessions: [],
      metadata: {},
      programs: [],
      inMeeting: this.$store.getters.GET_IN_MEETING
      // inMeeting: false
    };
  },
  mounted() {
    // this.inMeeting = window.localStorage.getItem('inMeeting');
    // window.addEventListener('storage', () => {
    //   this.inMeeting = window.localStorage.getItem('inMeeting');
    // });
  },
  async created() {
    // var date = new Date();
    // var options = { hour12: false };
    // var CurrentTime = date.toLocaleString("en-US", options);
    // this.timeNow = CurrentTime.split(",")[1];
    var date = new Date();
    var options = { hour12: false };
    var CurrentTime = date.toLocaleString("en-US", options);
    var time = CurrentTime.split(",")[1].split(":")[0];

    this.todayDate = moment().format('Y-MM-DD');

    this.ShowLoading();
    try {
      // let result = await this.axios.post(
      //   process.env.VUE_APP_APIEndPoint + "reserve/upcomings/",
      //   this.dataBody,
      //   this.headers
      // );
      //let currentHalaqa = result.data.data.upcoming_webinar;
      //let currentClasses = result.data.data.upcoming_sessions;
      //this.pages = currentHalaqa.concat(currentClasses);
      this.dataBody.session_offset = 0;
      this.dataBody.session_limit = this.limit;
      this.dataBody.webinar_offset = 0;
      this.dataBody.webinar_limit = this.limit;
      await this.getTutorClasses();
      await this.getAllPrograms();
    } finally {
      this.HideLoading();
    }
  },
  methods: {
    async getAllPrograms() {
      let url = process.env.VUE_APP_APIEndPoint + "tutor/programs/";
      let response = await this.axios.get(url, self.headers);
      if (response) {
        this.programs = response.data;
      }
    },
    async onPageChange({ page }) {
      this.ShowLoading();
      try {
        this.dataBody.session_offset = (page - 1) * this.limit ?? 0;
        this.dataBody.session_limit = this.limit;
        this.dataBody.webinar_offset = (page - 1) * this.limit ?? 0;
        this.dataBody.webinar_limit = this.limit;
        await this.getTutorClasses();
      } finally {
        this.HideLoading();
      }
    },
    async FilterData() {
      this.ShowLoading();
      try {
        if (this.course_type) {
          this.dataBody.course_type = this.course_type;
          this.dataBody.webinar_type = this.course_type;
          this.filterDataBody.course_type = this.course_type;
          this.filterDataBody.webinar_type = this.course_type;
        }
        if (this.dataBody.program) {
          this.filterByProgramme = true;
          this.filterDataBody.program = this.dataBody.program;
        }
        if (this.dataBody.from_date) {
          this.filterDataBody.from_date = this.dataBody.from_date;
        }
        if (this.dataBody.to_date) {
          this.filterDataBody.to_date = this.dataBody.to_date;
        }
        let result = await this.axios.post(
          process.env.VUE_APP_APIEndPoint + "reserve/upcomings/",
          this.filterDataBody,
          this.headers
        );
        let currentHalaqa = result.data.data.upcoming_webinar;
        let currentClasses = result.data.data.upcoming_sessions;
        this.pages = currentHalaqa.concat(currentClasses);
        // await this.getTutorClasses();
      } finally {
        this.HideLoading();
      }
    },
    async getTutorClasses() {
      const response = await this.axios.post(
        process.env.VUE_APP_APIEndPoint + "reserve/upcomings/",
        {},
        this.headers
      );

      if (response) {
        var currentHalaqa = response.data.data.upcoming_webinar;
        var currentClasses = response.data.data.upcoming_sessions;

        // check filter by program cuz halaqa doesn't have program field
        if (this.filterByProgramme) {
          var concatatedSections = currentClasses;
        } else {
          var concatatedSections = currentHalaqa.concat(currentClasses);
        }

        // sort array with date/time
        let allSections = concatatedSections.sort(function (a, b) {
          return (
            new Date(a.scheduled_utc_start_date_time) -
            new Date(b.scheduled_utc_start_date_time)
          );
        });

        this.upcommingSessions = [];
        var date = new Date();
        var options = { hour12: false };
        var CurrentTime = date.toLocaleString("en-US", options);
        var time = CurrentTime.split(",")[1].split(":")[0];
        if (time == 24) {
          this.timeNow = time - 24;
        } else {
          this.timeNow = CurrentTime.split(",")[1].trim();
        }
        for (let i in allSections) {
          if (allSections[i].course) {
            this.upcommingSessions.push({
              id: i,
              course_type: allSections[i].course_type,
              start_date: allSections[i].start_date,
              start_time: allSections[i].start_time,
              end_time: allSections[i].end_time,
              end_date: allSections[i].end_date,
              fees: allSections[i].session_fee,
              program_name: allSections[i].program.name,
              student_name: allSections[i].student
                ? allSections[i].student.first_name +
                  " " +
                  allSections[i].student.last_name
                : "_",
              type: allSections[i].class_type,
              zoom_meeting: allSections[i].zoom_meeting,
            });
          } else {
            this.upcommingSessions.push({
              id: i,
              course_type: allSections[i].webinar_type,
              start_date: allSections[i].start_date,
              end_time: allSections[i].end_time,
              start_time: allSections[i].start_time,
              fees: "--",
              program_name: "--",
              student_name: "--",
              type: allSections[i].class_type,
              zoom_meeting: allSections[i].zoom_meeting,
            });
          }
        }
      } else {
        console.log("error while getting tutor current classes....");
      }
    },
    async startZoomMeeting(item) {
      var user = this.$store.getters.StateUser?.user;
      let userId = user.id;
      let uid = btoa(userId.toString());
      let meetingId = item;
      let mid = btoa(meetingId.toString());
      this.$router.push({ name: "meeting", query: { uid: uid, mid: mid } });

      // let routeData = this.$router.resolve({
      //   name: "meeting",
      //   query: { uid: uid, mid: mid },
      // });
      // window.open(routeData.href, "_blank");
    },
    joinOnZoom(item) {
      var user = this.$store.getters.StateUser?.user;
      let userId = user.id;
      let uid = btoa(userId.toString());
      let meetingId = item;
      let mid = btoa(meetingId.toString());
      let data = {
        uid,
        mid,
      };
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/meeting/`,
          data,
          this.headers
        )
        .then((response) => {
          if (response) {
            window.open(response.data.data.zoom_meeting.join_meeting_url);
          }
        });
    },
    isSessionTime(item) {
      let startTimestamp = moment(`${item.start_date} ${item.start_time}`)
      // .tz(this.headers.headers["USER-TIMEZONE"])
      .unix();
      let endTimestamp = moment(`${item.end_date} ${item.end_time}`)
      // .tz(this.headers.headers["USER-TIMEZONE"])
      .unix();
      let currentTimestamp = moment(`${moment()
        // .tz(this.headers.headers["USER-TIMEZONE"])
      .format('D/M/Y HH:mm:ss')}`,
      'D/M/Y HH:mm:ss').unix();
      return currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp;
    },
    checkAllowedDates(date) {
      return date >= this.date.from_date_time;
    },
    clearFiltration(type) {
      delete this.dataBody[type];
      delete this.filterDataBody[type];
      this.FilterData();
    }
  },
  computed: {
    items() {
      return [
        {
          label: this.$t("Arabic"),
          value: "Arabic",
        },
        {
          label: this.$t("Quran"),
          value: "Quran",
        },
        {
          label: this.$t("Tajweed"),
          value: "Tajweed",
        },
      ];
    },
    headersTitles() {
      return [
        { text: this.$t("course_Type"), value: "course_type", sortable: false, align:'center'},
        { text: this.$t("Start_Date"), value: "start_date", sortable: false, align:'center' },
        { text: this.$t("Start_Time"), value: "start_time", sortable: false, align:'center' },
        { text: this.$t("Fees"), value: "fees", sortable: false, align:'center' },
        {
          text: this.$t("programName"),
          value: "program_name",
          sortable: false,
          align:'center'
        },
        { text: this.$t("studentName"), value: "student_name", sortable: false, align:'center' },
        { text: this.$t("Type"), value: "type", sortable: false, align:'center' },
        { text: this.$t("joinClassZoom"), value: "startOnZoom", sortable: false , align:'center' },
      ];
    },
  },
};
</script>

<style scoped>
.disabled-btn,
.disabled-btn:hover {
  background-color: #c0c5be;
}

td {
  padding: 9px;
}

td.text-xs-right,
th.text-start,
button.btn-round.add-student-btn {
  white-space: nowrap;
}

.student-subaccount-box--title-container {
  text-align: start !important;
}

.btn-round {
  padding: 4px 10px;
}

.action-btn{
  color: #fff;
}
</style>
